<template>
    <div class="not_defined">
        <div class="content_box">
            <div class="text">抱歉，没有找到页面</div>
            <!-- <el-button round @click="returnHome">返回首页</el-button> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        prevPage() {
            this.$router.go(-1);
        },

        returnHome() {
            this.$router.replace('/')
        }
    }
};
</script>

<style lang="scss">
.not_defined {
    display: flex;
    justify-content: center;
    align-items: center;
    .content_box {
        margin-top: 3rem;
        text-align: center;
        .icon {
            font-size: 2rem;
            color: #b1b4bb;
        }
        .text {
            margin: 1rem 0;
            font-size: 1rem;
            color: #999;
        }
    }
}
</style>
